import BaseModel from './BaseModel';

export default class GameModel extends BaseModel {
    constructor(obj)
    {
        super();
        this.initialize(obj);
    }

    initialize({
            sessionId = '',
            playId = null,

            availableStakes = [0.01, 1000],
            stake = 0.01,

            availableAutoSpins = [0, 1, 2, 3],
            autoSpins = 0,

            win = 0,
            cellModels = [],
            balance = 0
        } = {})
    {
        this.setProperty('sessionId', sessionId);
        this.setProperty('playId', playId);
        this.setProperty('availableAutoSpins', availableAutoSpins.slice().sort((a, b) => a - b));
        this.setProperty('minAutoSpins', Math.min.apply(null, availableAutoSpins));
        this.setProperty('maxAutoSpins', Math.max.apply(null, availableAutoSpins));
        this.setProperty('autoSpins', autoSpins);

        this.setProperty('availableStakes', availableStakes.slice().sort((a, b) => a - b));
        this.setProperty('minStake', Math.min.apply(null, availableStakes));
        this.setProperty('maxStake', Math.max.apply(null, availableStakes));
        this.setProperty('stake', stake);

        this.setProperty('win', Math.min(0, win));
        this.setProperty('cellModels', cellModels);
        this.setProperty('balance', balance);
    }



    /* ------------------ COMMON ------------------ */
    get balance()
    {
        return this.getProperty('balance') || 0;
    }

    set balance(value)
    {
        value = Math.max(0, parseFloat(value));
        this.setProperty('balance', value);
    }

    get playId()
    {
        return this.getProperty('playId') || null;
    }
    
    set playId( value )
    {
        return this.setProperty('playId', value);
    }
    
    get win()
    {
        return this.getProperty('win') || 0;
    }

    set win(value)
    {
        value = Math.abs(parseFloat(value) || 0);
        this.setProperty('win', value);
    }

    get cellModels()
    {
        return this.getProperty('cellModels').slice();
    }

    set cellModels(value)
    {
        this.setProperty('cellModels', [].concat(value));
    }

    /* ------------------ AUTOSPINS ------------------ */
    get minAutoSpins()
    {
        return this.getProperty('minAutoSpins');
    }

    get maxAutoSpins()
    {
        return this.getProperty('maxAutoSpins');
    }

    get autoSpins()
    {
        return this.getProperty('autoSpins');
    }

    set autoSpins(value)
    {
        value = parseInt(value) || 0;
        value = Math.max(this.minAutoSpins, value);
        value = Math.min(this.maxAutoSpins, value);
        this.setProperty('autoSpins', value);
    }



    /* ------------------ STAKES ------------------ */
    get minStake()
    {
        return this.getProperty('minStake');
    }

    get maxStake()
    {
        return this.getProperty('maxStake');
    }

    get stake()
    {
        return this.getProperty('stake') || 0;
    }

    set stake(value)
    {
        value = parseFloat(value) || 0;
        if (value < this.minStake)
        {
            value = this.minStake;
        }
        else if (value > this.maxStake)
        {
            value = this.maxStake;
        }

        this.setProperty('stake', value);
    }

    get availableStakes()
    {
        return this.getProperty('availableStakes') || [];
    }

    get availableAutoSpins()
    {
        return this.getProperty('availableAutoSpins') || [];
    }

    get sessionId()
    {
        return this.getProperty('sessionId') || [];
    }
}